export default __webpack_public_path__ + "static/media/thumbnail_01.b08da6b3.png";